/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Orgs_Empty1Inputs */

const en_coinvestments_insights_orgs_empty1 = /** @type {(inputs: Coinvestments_Insights_Orgs_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No organisations`)
};

/**
* | output |
* | --- |
* | "No organisations" |
*
* @param {Coinvestments_Insights_Orgs_Empty1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_orgs_empty1 = /** @type {((inputs?: Coinvestments_Insights_Orgs_Empty1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Orgs_Empty1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_orgs_empty1(inputs)
});
export { coinvestments_insights_orgs_empty1 as "coInvestments_insights_orgs_empty" }